var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('span',{staticClass:"card--title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"card--subtitle mb-3"},[_vm._v(_vm._s(_vm.subtitle))]),_c('span',{staticClass:"card--data"},[_vm._v(_vm._s(_vm.data))])])}
var staticRenderFns = []

export { render, staticRenderFns }